/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const RptAgendaCommercialeDtoEsitoEnum = {
    Annullata: 'ANNULLATA',
    Positivo: 'POSITIVO',
    Negativo: 'NEGATIVO',
    Neutro: 'NEUTRO',
    DaEseguire: 'DA_ESEGUIRE'
};
/**
 * @export
 */
export const RptAgendaCommercialeDtoModalitaContattoEnum = {
    Mail: 'MAIL',
    Telefono: 'TELEFONO',
    Incontro: 'INCONTRO'
};
/**
 * @export
 */
export const RptAgendaCommercialeDtoStatoAttivitaEnum = {
    Completate: 'COMPLETATE',
    ScaduteSenzaEsito: 'SCADUTE_SENZA_ESITO',
    PianificateOggi: 'PIANIFICATE_OGGI',
    Future: 'FUTURE',
    NonClassificate: 'NON_CLASSIFICATE'
};
/**
 * Check if a given object implements the RptAgendaCommercialeDto interface.
 */
export function instanceOfRptAgendaCommercialeDto(value) {
    return true;
}
export function RptAgendaCommercialeDtoFromJSON(json) {
    return RptAgendaCommercialeDtoFromJSONTyped(json, false);
}
export function RptAgendaCommercialeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'creationDate': json['creationDate'] == null ? undefined : (new Date(json['creationDate'])),
        'lastmodifiedDate': json['lastmodifiedDate'] == null ? undefined : (new Date(json['lastmodifiedDate'])),
        'actionDate': json['actionDate'] == null ? undefined : (new Date(json['actionDate'])),
        'clienteId': json['clienteId'] == null ? undefined : json['clienteId'],
        'opportunityId': json['opportunityId'] == null ? undefined : json['opportunityId'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'projectName': json['projectName'] == null ? undefined : json['projectName'],
        'strutturaBusinessId': json['strutturaBusinessId'] == null ? undefined : json['strutturaBusinessId'],
        'fkUtente': json['fkUtente'] == null ? undefined : json['fkUtente'],
        'denominazioneStrutturaBusiness': json['denominazioneStrutturaBusiness'] == null ? undefined : json['denominazioneStrutturaBusiness'],
        'denominazioneOpportunity': json['denominazioneOpportunity'] == null ? undefined : json['denominazioneOpportunity'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'margin': json['margin'] == null ? undefined : json['margin'],
        'esito': json['esito'] == null ? undefined : json['esito'],
        'modalitaContatto': json['modalitaContatto'] == null ? undefined : json['modalitaContatto'],
        'nota': json['nota'] == null ? undefined : json['nota'],
        'notaEsito': json['notaEsito'] == null ? undefined : json['notaEsito'],
        'nominativoCliente': json['nominativoCliente'] == null ? undefined : json['nominativoCliente'],
        'nomeAccount': json['nomeAccount'] == null ? undefined : json['nomeAccount'],
        'statoAttivita': json['statoAttivita'] == null ? undefined : json['statoAttivita'],
    };
}
export function RptAgendaCommercialeDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'creationDate': value['creationDate'] == null ? undefined : ((value['creationDate']).toISOString()),
        'lastmodifiedDate': value['lastmodifiedDate'] == null ? undefined : ((value['lastmodifiedDate']).toISOString()),
        'actionDate': value['actionDate'] == null ? undefined : ((value['actionDate']).toISOString().substring(0, 10)),
        'clienteId': value['clienteId'],
        'opportunityId': value['opportunityId'],
        'projectId': value['projectId'],
        'projectName': value['projectName'],
        'strutturaBusinessId': value['strutturaBusinessId'],
        'fkUtente': value['fkUtente'],
        'denominazioneStrutturaBusiness': value['denominazioneStrutturaBusiness'],
        'denominazioneOpportunity': value['denominazioneOpportunity'],
        'amount': value['amount'],
        'margin': value['margin'],
        'esito': value['esito'],
        'modalitaContatto': value['modalitaContatto'],
        'nota': value['nota'],
        'notaEsito': value['notaEsito'],
        'nominativoCliente': value['nominativoCliente'],
        'nomeAccount': value['nomeAccount'],
        'statoAttivita': value['statoAttivita'],
    };
}
